export default "__VITE_ASSET__bloKFl3$__"